<template>
  <b-card>
    <country />
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/Cities/elements/Title.vue'
import Country from '@/views/Admin/Defines/Cities/elements/Country.vue'

export default {
  name: 'CityForm',
  components: {
    BCard,
    TitleName,
    Country,
  },
}
</script>
